// extracted by mini-css-extract-plugin
export default {"wrapper":"PJZxp","description":"UWqFy","navArrowsContainer":"sDkgk","navTitle":"xQWOz","scrollbar":"KHVdP","itemWrapper":"bCd71","last":"r7GCF"};